import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["xlink:href", "fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    class: "svg-icon-wrapper",
    width: _ctx.props.size,
    height: _ctx.props.size,
    "aria-hidden": "true",
    fill: "currentColor"
  }, [
    _createElementVNode("title", null, _toDisplayString(_ctx.props.title), 1),
    _createElementVNode("use", {
      "xlink:href": `#icon-${_ctx.props.name}`,
      fill: _ctx.props.color
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}